import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosInstance } from 'axios'
import { CustomerRFPDocumentSummary } from '@black-bear-energy/black-bear-energy-common'
import { useApiWithIDTokenGranted } from '../../state/modules/common'

/**
 * Fetch a customer RFP document summary.
 * @param customerRFPId - The ID of the customer RFP.
 * @returns A UseQueryResult object containing the customer RFP document summary.
 */
export const useCustomerRFPDocumentSummary = (
  customerRFPId: number
): UseQueryResult<CustomerRFPDocumentSummary, Error> => {
  const api = useApiWithIDTokenGranted()

  return useQuery({
    queryKey: [api, 'customerRFPDocumentSummary', customerRFPId],
    queryFn: () =>
      fetchCustomerRFPDocumentSummary(api as AxiosInstance, customerRFPId),
    enabled: !!api,
  })
}

async function fetchCustomerRFPDocumentSummary(
  api: AxiosInstance,
  customerRFPId: number
): Promise<CustomerRFPDocumentSummary> {
  const response = await api.get<CustomerRFPDocumentSummary>(
    `/customer-rfps/${customerRFPId}/customer-rfp-document-summary`
  )
  return response.data
}
